export enum PaymentOptionEnum {
  Aircash = 'Aircash',
  CreditCard = 'CreditCard',
  KeksPay = 'KeksPay',
}